import { useCallback } from 'react'

export function usePendoEvents() {
  const trackEvent = useCallback((eventKey, eventDetails) => {
    window.pendo.track(eventKey, eventDetails)
  }, [])

  return {
    trackEvent,
  }
}
